<template>
  <div>
    <p>日均短信折线图</p>
    <div id="Short" :style="{width: '90%', height: '300px'}" />
  </div>
</template>
<script>
import Vue from 'vue'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
export default {
  name: 'Hello',
  props: ["message9"],
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  watch: {
    message9: function(newVal, oldVal) {
      let times = [];
      let total = [];
      newVal.map(function(value, index) {
        times.push(value.dateTime)
        total.push(value.total)
      });
      this.drawLine(times,total);
    }
  },
  methods: {
    drawLine(a,s) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(document.getElementById('Short'))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['短信数量']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data:a
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '短信数量',
            type: 'line',
            stack: '总量',
            data: s
          }
        ]
      })
    }
  }
}
</script>
